import { call, put, takeLatest } from 'redux-saga/effects';

import { BillingApi } from '@apis/BillingApi';
import { PaymentTransactionApi } from '@apis/PaymentTransactionApi';
import { Billing } from '@models/Billing';
import { PaymentTransaction } from '@models/PaymentTransaction';
import { SagaPayload } from '@utils/typescript';
import { HealthQuoteApi } from '@apis/HealthQuoteApi';
import { HealthQuote } from '@models/HealthQuote';

import {
  healthQuoteFetch,
  HealthQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
  paymentTransactionCreate,
  PaymentTransactionCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleHealthQuoteFetch({ payload }: SagaPayload<HealthQuoteFetchPayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.get, payload)) as HealthQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleBillingFetch({ payload }: SagaPayload<BillingFetchPayload>) {
  const state: StateUpdatePayload = { billing: null };
  try {
    state.billing = (yield call(BillingApi.get, payload)) as Billing;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePaymentTransactionCreate({ payload }: SagaPayload<PaymentTransactionCreatePayload>) {
  const state: StateUpdatePayload = { paymentTransaction: null };
  try {
    state.paymentTransaction = (yield call(PaymentTransactionApi.create, payload)) as PaymentTransaction;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(healthQuoteFetch, handleHealthQuoteFetch);
  yield takeLatest(billingFetch, handleBillingFetch);
  yield takeLatest(paymentTransactionCreate, handlePaymentTransactionCreate);
}
